import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { fmt, proxyImg } from "../lib/format";
import { Package, Calendar } from "lucide-react";

export default function Account() {
  const { user, loading } = useAuth();
  const [orders, setOrders] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && !user) nav("/login");
  }, [user, loading, nav]);

  useEffect(() => {
    if (user) api.get("/orders").then((r) => setOrders(r.data));
  }, [user]);

  if (!user) return null;

  return (
    <div className="pt-32 pb-24" data-testid="account-page">
      <div className="max-w-5xl mx-auto px-5 md:px-10">
        <div className="mb-10">
          <div className="eyebrow mb-3">Minha conta</div>
          <h1 className="h-display text-5xl mb-2">Olá, {user.name?.split(" ")[0]}</h1>
          <p className="text-ink-secondary">{user.email}</p>
        </div>

        <h2 className="font-heading text-3xl mb-6 flex items-center gap-3">
          <Package size={22} className="text-brand-accent" /> Meus pedidos
        </h2>

        {orders.length === 0 ? (
          <div className="bg-white rounded-3xl p-10 text-center border border-black/5">
            <p className="text-ink-secondary mb-5">Você ainda não tem pedidos.</p>
            <Link to="/loja" className="btn-primary">Explorar catálogo</Link>
          </div>
        ) : (
          <div className="space-y-4">
            {orders.map((o) => (
              <div key={o.order_id} className="bg-white rounded-3xl p-6 border border-black/5" data-testid={`order-${o.order_id}`}>
                <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-4">
                  <div>
                    <div className="text-xs font-tech uppercase tracking-widest text-ink-secondary">Pedido</div>
                    <div className="font-tech text-lg">{o.order_id}</div>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-ink-secondary">
                    <Calendar size={14} />
                    {new Date(o.created_at).toLocaleDateString("pt-BR")}
                  </div>
                  <span className={`px-4 py-1.5 rounded-full text-xs font-tech uppercase tracking-widest ${
                    o.status === "paid" ? "bg-status-success/15 text-status-success" : "bg-bg-tertiary text-ink-secondary"
                  }`}>
                    {o.status === "paid" ? "Pago" : "Pendente"}
                  </span>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
                  {o.items.slice(0, 4).map((it) => (
                    <img key={it.product_id} src={proxyImg(it.image)} alt="" className="aspect-square rounded-xl bg-bg-secondary p-2 object-contain" />
                  ))}
                </div>
                <div className="flex justify-between items-center pt-4 border-t border-black/5">
                  <span className="text-sm text-ink-secondary">{o.items.length} item(s)</span>
                  <span className="font-heading text-2xl">{fmt(o.total)}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
